$(document).ready(function() {
    var cname = "localization";
    //var cname = "GlobalE_Data";
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            var cookie = c.substring(name.length, c.length);
        }
    }
    cookie = cookie.includes("US");
	const mediaQuery = window.matchMedia('(min-width: 1025px)')
    if( cookie == false && mediaQuery.matches) {
        $(".collection-container__header").css("margin-top","0px");
    }
});